import { render, staticRenderFns } from "./AgeVerificationStatusBanner.vue?vue&type=template&id=7d20cef3&"
import script from "./AgeVerificationStatusBanner.vue?vue&type=script&lang=ts&"
export * from "./AgeVerificationStatusBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports